import type { ScheduleModeConfig } from '../schedule.types';

export const adhocModeConfig: ScheduleModeConfig = {
  key: 'adhoc',
  navigationStyle: 'stepper',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'communication', label: 'Communication' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: false,
};
